import { convertBytesToGigaBytes } from '@logz-pkg/utils';
import { DailyUsage, PlanUsageBucketModel } from '@logz-pkg/models';

export const getLogManagementDailyUsage = (dailyUsage: PlanUsageBucketModel[]): DailyUsage[] =>
  dailyUsage.map(usage => ({ date: new Date(+usage.date), value: convertBytesToGigaBytes(usage.bytes) }));
